import React from 'react';
import { buttonClassNames } from './buttonClassNames';

const Button = ({
  children,
  onClick,
  className = '',
  variant = 'default',
  type = 'button',
  disabled = false,
  id,
  name,
  'aria-label': ariaLabel,
  'aria-disabled': ariaDisabled,
}) => {
  return (
    <button
      type={type}
      id={id}
      name={name}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-disabled={ariaDisabled ?? (disabled ? true : undefined)}
      className={buttonClassNames({ variant, disabled, className })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
